// NOTE: All entities keys of string fields with font awesome icons
export const fieldKeysOfEntitiesWithFontAwesomeSelectors = [
  'closedIconClassName',
  'iconClassName',
  'iconClassNameAfter',
  'iconClassNameBefore',
  'listItemClassName',
]

// NOTE: Use this enum for font awesome icons in publisher. It's for optimization
export enum publisherFontAwesomeIconsEnum {
  ChevronCircleLeftLight = 'fal fa-chevron-circle-left',
  ChevronCircleRightLight = 'fal fa-chevron-circle-right',
  ChevronDownSolid = 'fas fa-chevron-down',
  ChevronLeftSolid = 'fas fa-chevron-left',
  ChevronRightDuotone = 'fad fa-chevron-right',
  ChevronRightSolid = 'fas fa-chevron-right',
  ChevronUpSolid = 'fas fa-chevron-up',
  CircleSolid = 'fas fa-circle',
  ClockRegular = 'far fa-clock',
  EyeRegular = 'far fa-eye',
  EyeSlashRegular = 'far fa-eye-slash',
  Times = 'fa fa-times',
}
